import React, {Component} from 'react';
import Bubbles from './Bubbles';
import * as d3 from 'd3';
import {uniq, countBy} from 'lodash';

const EMOJI_SIZE = 0.068; // size of emoji as a percentage of svg width/height

class BubbleGroup extends Component{
  ref = null;
  state = {
    data: {}
  }

  componentDidMount(){
    const dim = this.ref.getBoundingClientRect();
    const width = dim.width;
    const height = dim.height;

    this.size = [width, height];
    // console.log('cat', uniq(this.props.data.map(d => d.subgroup)));
    console.log(this.getCategoryList());
    this.setState({data: createCountNodes(this.props.data, width, height)})
  }

  getCategoryList(){
    let counts = countBy(this.props.data, 'subgroup');
    let sortcount = Object.entries(counts).map(d => {return({'cat': d[0], 'count': d[1]})})
                          .sort((a,b) => b.count - a.count)
                          .map(d => d.cat);
    return sortcount;
  }

  render(){
    const {view, data} = this.state;

    return(
      <svg className='bubblesbox' ref={(ref) => this.ref = ref}>
        {/* {this.ref !== null && <rect x={this.size[0]/2} y={this.size[1]/2} fill='red' width='10' height='10'></rect>} */}
        {data.length > 0 && <Bubbles data={data} size={this.size}/>}
        {/* {data.length > 0 && data.map(d => <Bubbles data={d} center={this.center} forceStrength={forceStrength}/>)} */}
      </svg>
    )
  }

}

export default BubbleGroup;

// helper function to parse the data
const createCountNodes = (rawData, width, height) => {
  let arr = [];
  rawData.map( d => {
    for (let i=0; i<d.nn; i++){

      arr.push({
      id: d.emojis+d.unicode,
      width: width*EMOJI_SIZE,
      height: width*EMOJI_SIZE,
      name: d.name,
      group: d.group,
      subgroup: d.subgroup,
      unicode: d.unicode,
      x: Math.random()*(width - EMOJI_SIZE*width),
      y: 0
      // x: Math.random()*(width - EMOJI_SIZE*width),
      // y: Math.random()*(height- EMOJI_SIZE*width),
    })


  }})
      return arr;

}


const fillColor = () => {
  d3.scaleOrdinal()
  .domain(d3.range(8))
  .range(["#f55e65", "#7c004f", "#1a737b", "#01d1c1", "#a8e49c", "#ffb400", "#ffaa91", "#b3a76b", '#9ca19a']);
}



// WEBPACK FOOTER //
// ./src/Charts/BubbleGroup/BubbleGroup.js